import { useUser } from "hooks";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "redux/store";

const Root = () => {
  const user = useUser()[0]; //accessing user from useUser hook
  const isOtpVerified = sessionStorage.getItem("isOtpVerified") === "true";
  
  const getRootUrl = (): string => {
    if (user?.token) {
      if (user.otpEnabled) {
        return isOtpVerified ? "dashboard/my" : "account/login";
      } else {
        return "dashboard/my";
      }
    }
    return "account/login";
  };

  const url = getRootUrl();

  return <Navigate to={`/${url}`} />;
};

export default Root;
